// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReturnHeader_wrapper__BvfHs","right-text":"ReturnHeader_right-text__ChxkH","return-link":"ReturnHeader_return-link__IRz7u"};